import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initMixpanel, trackMixpanelPageView } from '../../analytics/mixpanel';

/** Tracks SPA route changes for Mixpanel (initial HTML load alone is not enough). */
export function MixpanelPageTracker(): null {
  const location = useLocation();

  useEffect(() => {
    initMixpanel();
  }, []);

  useEffect(() => {
    trackMixpanelPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
